import React, { useEffect, useMemo, useState } from "react";
import Header from "./Header";
// import StoreMapping from "./StoreMapping";
// import WorkAllocation from "./WorkAllocation";
import WorkAllocation from "../../../components/AdminportalFolder/Campaign/WorkAllocation.js";
// import DataTable from "./DataTable";
import DataTable from "../../../components/AdminportalFolder/Campaign/DataTable.js";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Campaign } from "@mui/icons-material";
import StoreMapping from "../../AdminportalFolder/Campaign/StoreMapping";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

const shimmerStyle = {
  background: "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
  backgroundSize: "1000px 100%",
  animation: "shimmer 1.5s infinite linear",
};

const CampaignDashboard = () => {
  const { id } = useParams();
  let serverURL = process.env.REACT_APP_URL;

  const [CampaignDetails, setCampaignDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const FetchDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${serverURL}/campaign/viewCampaign/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        setCampaignDetails(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const uniqueProductTypes = useMemo(() => {
    if (!CampaignDetails?.locations) return [];
    const types = CampaignDetails.locations
      .filter((loc) => loc.product?.productType) // only keep ones with productType
      .map((loc) => loc.product.productType);

    return ["All", ...Array.from(new Set(types))];
  }, [CampaignDetails?.locations]);

  const [productType, setProductType] = useState([]);
  useEffect(() => {
    FetchDetails();
  }, []);
  const SkeletonLoader = () => (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -1000px 0; }
            100% { background-position: 1000px 0; }
          }
        `}
      </style>

      <div className="space-y-6">
        {/* Header skeleton */}
        <div className="h-10 w-1/3 rounded" style={shimmerStyle}></div>
        <div className="h-6 w-1/4 rounded" style={shimmerStyle}></div>

        {/* Grid skeleton */}
        <div className="flex flex-col gap-6 mt-6 xl:grid xl:grid-cols-2">
          <div className="h-48 rounded-xl" style={shimmerStyle}></div>
          <div className="h-48 rounded-xl" style={shimmerStyle}></div>
        </div>

        {/* Table skeleton */}
        <div className="mt-6 space-y-3">
          {Array(5)
            .fill(0)
            .map((_, i) => (
              <div
                key={i}
                className="h-6 w-full rounded"
                style={shimmerStyle}
              ></div>
            ))}
        </div>
      </div>
    </>
  );

  return (
    <div className="bg-gray-50 p-8">
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          <Header CampaignDetails={CampaignDetails} productType={productType} />

          <div className="bg-white shadow-md rounded-xl p-4 flex items-center space-x-4  h-auto w-[300px] mt-[8px] ">
            <FormControl className="w-64" size="small">
              <Select
                name="productType"
                multiple
                displayEmpty
                value={productType}
                onChange={(e) => {
                  const {
                    target: { value },
                  } = e;

                  let selected =
                    typeof value === "string" ? value.split(",") : value;

                  if (selected?.includes("All")) {
                    if (productType?.includes("All")) {
                      selected = []; // unselect all
                    } else {
                      selected = ["All"]; // only "All"
                    }
                  }

                  setProductType(selected);
                }}
                renderValue={(selected) => {
                  if (selected?.length === 0) {
                    return (
                      <p className="text-[1rem] text-[#a2a2a2]">
                        Choose product types
                      </p>
                    );
                  }
                  if (selected?.includes("All")) {
                    return "All Products"; // 👈 Clean label
                  }
                  if (selected?.length > 2) {
                    return `No of Product ${selected?.length}`;
                  }
                  return selected?.join(", ");
                }}
              >
                {uniqueProductTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    <Checkbox checked={productType?.includes(type)} />
                    <ListItemText
                      primary={type === "All" ? "All Products" : type}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Store Mapping and Work Allocation */}
          <div className="flex flex-col gap-6 mt-6 xl:grid xl:grid-cols-2">
            <StoreMapping
              CampaignDetails={CampaignDetails}
              setProductType={setProductType}
              productType={productType}
            />
            <WorkAllocation
              CampaignDetails={CampaignDetails}
              setProductType={setProductType}
              productType={productType}
            />
          </div>

          {/* Data Table */}
          <DataTable CampaignDetails={CampaignDetails} />
        </>
      )}
    </div>
  );
};

export default CampaignDashboard;
